import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./Router/AppRouter";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppRouter></AppRouter>);
